<template>
    <div>
        <v-tabs
            v-model="selectedTab"
            height="2.5rem"
            background-color="transparent"
            class="promo-tabs"
            active-class="promo-tabs__tab--active"
            hide-slider
        >
            <template v-for="tab in tabs" :key="`tab-group-${tab.label}`">
                <!-- Used to fill and style the space between tabs. -->
                <div class="promo-tabs__spacer" />
                <v-tab :disabled="tab.disabled" class="promo-tabs__tab">
                    {{ toSentenceCase(tab.label) }}
                </v-tab>
            </template>
            <!-- Used to fill and style the remaining space from the last tab to the end of the tabs container. -->
            <div class="promo-tabs__filler" />
        </v-tabs>

        <v-tabs-window v-model="selectedTab">
            <v-tabs-window-item
                v-for="tab in tabs"
                :key="`tab-item-${tab.label}`"
                :transition="false"
                :reverse-transition="false"
            >
                <!-- Only display the grids if we are on the channels tab - this is for performance & to ensure we display the correct data -->
                <div v-if="tab.component && isOnChannelTab">
                    <component
                        :is="tab.component"
                        :namespace="namespace"
                        :promotion-editing-state="promotionEditingState"
                    />
                </div>
            </v-tabs-window-item>
        </v-tabs-window>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import featureFlags from '@enums/feature-flags';
import promotionTabs from '@enums/promotion-tabs';

const localizationKey = 'planning.promotionsMaintenance.resources.featuredProducts';

export default {
    props: {
        namespace: {
            required: true,
            type: String,
        },
        promotionEditingState: {
            type: Object,
            required: true,
        },
        cacheDom: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            selectedTab: 0, // Set the first tab to be the default.
        };
    },

    computed: {
        ...mapState('clientConfig', ['toggleLogic', 'releaseFlags']),
        ...mapState('promotions', ['selectedPromotionMaintenanceTab']),

        tabs() {
            let tabsToDisplay;
            if (this.releaseFlags.releaseFlags.useCombinedRankingAndStoreProvisionTab) {
                tabsToDisplay = [
                    {
                        label: `${this.$t(
                            `${localizationKey}.rankingAndSecondPlacementTabHeading`
                        )}`,
                        disabled: false,
                        component: 'ranking-and-placement',
                    },
                ];
            } else {
                tabsToDisplay = [
                    {
                        label: this.$t(`${localizationKey}.rankingTabHeading`),
                        disabled: false,
                        component: 'ranking-tab',
                    },
                    {
                        label: this.$t(`${localizationKey}.storeProvisionTabHeading`),
                        disabled: false,
                        component: 'store-provision-grid',
                    },
                ];
            }

            if (this.toggleLogic[featureFlags.canEditListPrice]) {
                tabsToDisplay.push({
                    label: this.$t(`${localizationKey}.listPriceTabHeading`),
                    disabled: false,
                    component: 'list-price-grid',
                });
            }

            return tabsToDisplay;
        },
        isOnChannelTab() {
            return this.cacheDom || this.selectedPromotionMaintenanceTab === promotionTabs.channels;
        },
    },
};
</script>

<style lang="scss" scoped></style>
